console.log('process.env', process.env)
// export const MQTT_SERVICE = 'ws://8.129.218.249:8083/mqtt'
// gemone 服务器
// export const MQTT_SERVICE = 'wss://gemone-emq.gpdcloud.net:8084/mqtt'
// export const MQTT_USERNAME = 'yhub_admin'
// export const MQTT_PASSWORD = 'FT7t3e9Hx4Ql7H4'

// 香港服务器
let server = 'wss://emq.gpdcloud.net:8083/mqtt'
let user = 'admin'
let pw = 'public'

if (process.env.VUE_APP_SERVER == '2') {
  server = 'wss://gemone-emq.gpdcloud.net:8084/mqtt'
  user = 'yhub_admin'
  pw = 'FT7t3e9Hx4Ql7H4'
}

export const MQTT_SERVICE = server;
export const MQTT_USERNAME = user;
export const MQTT_PASSWORD = pw;
